<template>
	<md-card>
		<md-card-header class="md-card-header-icon md-card-header-blue">
			<div class="md-layout">
				<div class="md-layout-item">
					<div class="card-icon">
                        <font-awesome-icon class="md-icon" :icon="['fa', icon]" />
					</div>
					<h4 class="title">{{ title }}</h4>
				</div>
				<div class="md-layout-actions md-layout-item md-size-40 text-right align-center mt-3">
					<div class="flex items-center space-x-4 divide-x-2 justify-end header-actions">
						<slot name="header-actions"></slot>
					</div>
				</div>
			</div>
		</md-card-header>
        <slot name="content"></slot>
	</md-card>
</template>

<script>
export default {
	name: "SiteCard",
	props: {
		title: String,
		icon: String,
		actions: Boolean
	}
}
</script>

<style scoped lang="scss">
.md-card-header-icon {
	svg {
		color: #FFFFFF;
	}
}

::v-deep {
	.header-actions {
		max-height: 33px;
		min-height: 33px;
		width: 100%;

		.md-button {
			width: auto;
			padding: 7.5px 5px;

			.md-icon {
				font-size: .875rem !important;
				min-width: .875rem !important;
				height: .875rem !important;
				color: #FFFFFF !important;
			}
		}
	}
}
</style>
